export default {"src":"/_next/static/media/ic-main-logo.cf71e748.svg","height":28,"width":141,"blurWidth":0,"blurHeight":0};